
import './App.css';
import Galarey from './Components/Galarey';
function App() {
  return (
   <div>
    <Galarey/>
   </div>
  );
}

export default App;
